module.exports = {

  CalculationDate: '01/07/2025',
  FSSInsurancePremium: 242,
  InsurancePremium: null,
  IncomeProtectionInsurancePremium: 0,

  EnforceSGCRatesOfContribution: true,
  EnforceMaximumContributionBase: false,
  OverrideFundDefaultInsurancePremiums: false,

  // current age, whole years
  AgeNow: 40,

  // if true, show age pension payments as the total for the household rather than the individual
  AgePensionAllowCouplePensions: true,

  // SGC, can be set higher or lower if an employer pays a different amount.
  // Note, if employer pays higher than SGC, but less than 12% then the contributions will be increased over tie to 12% in-line with the increases in SGC.
  // If the employer pays less than SGC then the exact employer rate will always be used.
  EmployerContributionRate: 0.12,

  // if true, force minimum drawings during drawdown phase. If false minimum drawing limits will be ignored.
  EnforceMinimumDrawingRequirements: true,

  // is the user a homeowner - used for age pension eligibility tests
  HomeOwner: true,

  // include age pensions payments in the output
  IncludeAgePension: true,

  // run a simple TTR strategy (attempt to match current take home pay while maximising Super contributions)
  IncludeTTR: false,

  // array of investment scenarios to be run. properties match pre-configured investment options defined in the model configuration
  InvestmentOption: 4,

  // as above, investment choice during the drawdown phase
  // note: array length should match InvestmentOption.length
  InvestmentOptionInRetirement: 4,

  // users marital status - used for age pension eligibility tests
  Married: true,

  // users other assets - used for age pension eligibility tests
  OtherAssets: 0,

  // users inome outside of super - used for age pension eligibility tests
  OtherIncome: 0,

  // one off contribution amount ($'s)
  OneOffContribution: 0,

  // one off contribution age (whole years only, must be greater or equal to current age and less than retirement age)
  OneOffContributionMadeAtAge: 40,

  // number of days per week worked (0 for career break) - can be any fraction of a work week
  PartTimeWorkDaysPerWeek: 0,

  // age at which part time work / career break commences (whole years only, must be greater or equal to current age and less than retirement age)
  PartTimeWorkFromAge: 40,

  // number of years of part time work / career break (whole years only, total duration cannot exceed time between current age and retirement age)
  PartTimeWorkYearsDuration: 0,

  // after tax (non-concessional) contributions ($'s / year)
  PostTaxMemberContributions: 0,

  // before tax (concessional) contributions ($'s / year)
  PreTaxMemberContributions: 0,

  // retirement age (must be greater or equal to the greater of preservation age or ageNow)
  RetirementAge: 67,
  RetirementAge_2: 67,


  // user salary ($'s / year)
  Salary: 70000,

  // user gender ("male" / "female")
  Sex: 'Female',

  // current super balance
  SuperannuationBalance: 100000,

  // target income (annual drawdown amount during retirement)
  TargetIncome: 50000,

  // value of any lumpsum withdrawal at retirement ($'s)
  WithdrawalAtRetirement: 0,

  // Investment options
  InvestmentOptions: {
    investmentOption_0: {
      id: 1,
      name: 'Low risk',
      grossReturn: 0.045,
      taxableFraction: 0.66667,
      feePercentageOnBalance: 0,
      feePercentageOnBalanceCapped: 0.0006,
      feePercentageOnBalanceCappedCap: 500,
      feePercentageOnContributions: 0,
      feeAnnualDollar: 62.40,
    },
    investmentOption_1: {
      id: 2,
      name: 'Medium / Low risk',
      grossReturn: 0.055,
      taxableFraction: 0.66667,
      feePercentageOnBalance: 0,
      feePercentageOnBalanceCapped: 0.0006,
      feePercentageOnBalanceCappedCap: 500,
      feePercentageOnContributions: 0,
      feeAnnualDollar: 62.40,
    },
    investmentOption_2: {
      id: 3,
      name: 'Medium risk',
      grossReturn: 0.06,
      taxableFraction: 0.5556,
      feePercentageOnBalance: 0,
      feePercentageOnBalanceCapped: 0.0006,
      feePercentageOnBalanceCappedCap: 500,
      feePercentageOnContributions: 0,
      feeAnnualDollar: 62.40,
    },
    investmentOption_3: {
      id: 4,
      name: 'Medium / High risk',
      grossReturn: 0.065,
      taxableFraction: 0.51282,
      feePercentageOnBalance: 0,
      feePercentageOnBalanceCapped: 0.0006,
      feePercentageOnBalanceCappedCap: 500,
      feePercentageOnContributions: 0,
      feeAnnualDollar: 62.40,
    },
    investmentOption_4: {
      id: 5,
      name: 'High risk',
      grossReturn: 0.070,
      taxableFraction: 0.47619,
      feePercentageOnBalance: 0,
      feePercentageOnBalanceCapped: 0.0006,
      feePercentageOnBalanceCappedCap: 500,
      feePercentageOnContributions: 0,
      feeAnnualDollar: 62.40,
    },
    investmentOption_5: {
      id: 6,
      name: 'Custom',
      grossReturn: 0.0635,
      taxableFraction: 0.4866,
      feePercentageOnBalance: 0,
      feePercentageOnBalanceCapped: 0.0006,
      feePercentageOnBalanceCappedCap: 500,
      feePercentageOnContributions: 0,
      feeAnnualDollar: 62.40,
    },
  },

  //
  //

  SunSuper_50: {
    startAge: 55,
    male: [
      32,
      31,
      30,
      29,
      28,
      27,
      26,
      25,
      24,
      23,
      22,
      21,
      20,
      19,
      18,
      17,
      16,
      15,
      14,
      13,
      13,
    ],
    female: [
      35,
      34,
      33,
      32,
      31,
      30,
      29,
      28,
      27,
      26,
      24,
      23,
      22,
      21,
      20,
      19,
      18,
      17,
      16,
      15,
      14,
    ],
  },

  SunSuper_10: {
    startAge: 55,
    male: [
      42,
      41,
      40,
      39,
      38,
      37,
      36,
      35,
      34,
      33,
      32,
      31,
      30,
      29,
      28,
      27,
      26,
      25,
      24,
      23,
      22,
    ],
    female: [
      44,
      43,
      42,
      41,
      40,
      39,
      38,
      37,
      36,
      34,
      33,
      32,
      31,
      30,
      29,
      28,
      27,
      26,
      25,
      24,
      23,
    ],
  },

  EmployerAccrualTable: {
    rate_1: {
      contributionRate: 0.0,
      memberType: 'qsuper',
      accrualRate: 0.0,
    },
    rate_2: {
      contributionRate: 0.01,
      memberType: 'qsuper',
      accrualRate: 0.0,
    },
    rate_3: {
      contributionRate: 0.02,
      memberType: 'qsuper',
      accrualRate: 0.135,
    },
    rate_4: {
      contributionRate: 0.03,
      memberType: 'qsuper',
      accrualRate: 0.16,
    },
    rate_5: {
      contributionRate: 0.04,
      memberType: 'qsuper',
      accrualRate: 0.185,
    },
    rate_6: {
      contributionRate: 0.05,
      memberType: 'qsuper',
      accrualRate: 0.21,
    },
    rate_7: {
      contributionRate: 0.0,
      memberType: 'qpolice',
      accrualRate: 0.0,
    },
    rate_8: {
      contributionRate: 0.01,
      memberType: 'qpolice',
      accrualRate: 0.0,
    },
    rate_9: {
      contributionRate: 0.02,
      memberType: 'qpolice',
      accrualRate: 0.0,
    },
    rate_10: {
      contributionRate: 0.03,
      memberType: 'qpolice',
      accrualRate: 0.14,
    },
    rate_11: {
      contributionRate: 0.04,
      memberType: 'qpolice',
      accrualRate: 0.175,
    },
    rate_12: {
      contributionRate: 0.05,
      memberType: 'qpolice',
      accrualRate: 0.21,
    },
    rate_13: {
      contributionRate: 0.06,
      memberType: 'qpolice',
      accrualRate: 0.245,
    },
    rate_14: {
      contributionRate: 0.0,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_15: {
      contributionRate: 0.01,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_16: {
      contributionRate: 0.02,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_17: {
      contributionRate: 0.03,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_18: {
      contributionRate: 0.04,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_19: {
      contributionRate: 0.05,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_20: {
      contributionRate: 0.06,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_21: {
      contributionRate: 0.07,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_22: {
      contributionRate: 0.08,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_23: {
      contributionRate: 0.09,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
    rate_24: {
      contributionRate: 0.1,
      memberType: 'AGEST',
      accrualRate: 0.0,
    },
  },

  EmployerContributionTable: {
    rate_1: {
      contributionRate: 0.0,
      memberType: 'qsuper',
      accumulationContributionRate: 0.09,
    },
    rate_2: {
      contributionRate: 0.01,
      memberType: 'qsuper',
      accumulationContributionRate: 0.0,
    },
    rate_3: {
      contributionRate: 0.02,
      memberType: 'qsuper',
      accumulationContributionRate: 0.0975,
    },
    rate_4: {
      contributionRate: 0.03,
      memberType: 'qsuper',
      accumulationContributionRate: 0.1075,
    },
    rate_5: {
      contributionRate: 0.04,
      memberType: 'qsuper',
      accumulationContributionRate: 0.1175,
    },
    rate_6: {
      contributionRate: 0.05,
      memberType: 'qsuper',
      accumulationContributionRate: 0.1275,
    },
    rate_7: {
      contributionRate: 0.0,
      memberType: 'qpolice',
      accumulationContributionRate: 0.09,
    },
    rate_8: {
      contributionRate: 0.01,
      memberType: 'qpolice',
      accumulationContributionRate: 0.0,
    },
    rate_9: {
      contributionRate: 0.02,
      memberType: 'qpolice',
      accumulationContributionRate: 0.0,
    },
    rate_10: {
      contributionRate: 0.03,
      memberType: 'qpolice',
      accumulationContributionRate: 0.12,
    },
    rate_11: {
      contributionRate: 0.04,
      memberType: 'qpolice',
      accumulationContributionRate: 0.14,
    },
    rate_12: {
      contributionRate: 0.05,
      memberType: 'qpolice',
      accumulationContributionRate: 0.16,
    },
    rate_13: {
      contributionRate: 0.06,
      memberType: 'qpolice',
      accumulationContributionRate: 0.18,
    },
  },

  GovernmentIncomeProtectionTable: {
    startAge: 16,
    cost: [
      0.00296,
      0.00297,
      0.00302,
      0.00309,
      0.00322,
      0.00329,
      0.00345,
      0.00369,
      0.00392,
      0.00419,
      0.00443,
      0.0047,
      0.00499,
      0.00525,
      0.00551,
      0.00594,
      0.00633,
      0.00684,
      0.00738,
      0.00795,
      0.0084,
      0.00897,
      0.00951,
      0.00999,
      0.01036,
      0.0109,
      0.01125,
      0.01158,
      0.01189,
      0.01227,
      0.01268,
      0.01305,
      0.01332,
      0.01385,
      0.01434,
      0.01498,
      0.01571,
      0.01665,
      0.01736,
      0.01837,
      0.01938,
      0.02069,
      0.02193,
      0.02376,
      0.02532,
      0.02767,
      0.02933,
      0.02904,
      0.01591,
      0,
      0,
      0,
      0,
      0,
    ],
  },

  PoliceIncomeProtectionTable: {
    startAge: 16,
    cost: [
      0.00079,
      0.0008,
      0.00081,
      0.00083,
      0.00087,
      0.00088,
      0.00092,
      0.00096,
      0.00099,
      0.00104,
      0.0011,
      0.00114,
      0.00121,
      0.00129,
      0.00132,
      0.00143,
      0.00155,
      0.00166,
      0.00179,
      0.0019,
      0.00202,
      0.00212,
      0.00224,
      0.00234,
      0.00246,
      0.00255,
      0.00267,
      0.0028,
      0.00294,
      0.00306,
      0.00325,
      0.0034,
      0.00351,
      0.00364,
      0.00379,
      0.00402,
      0.00421,
      0.00446,
      0.00477,
      0.00506,
      0.0053,
      0.00571,
      0.00433,
      0.00057,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ],
  },

  NonGovernmentIncomeProtectionTable: {
    startAge: 16,
    cost: [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ],
  },

  SunSuperDeathTPDMale: {
    startAge: 15,
    cost: [
      2.0,
      2.0,
      2.0,
      2.0,
      2.0,
      2.0,
      2.0,
      3.52,
      3.52,
      3.52,
      3.52,
      3.52,
      3.52,
      3.52,
      3.52,
      6.4,
      6.4,
      6.4,
      6.4,
      6.4,
      6.4,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      7.56,
      3.96,
      3.96,
      3.96,
    ],
  },

  SunSuperDeathTPDFemale: {
    startAge: 15,
    cost: [
      1.2,
      1.2,
      1.2,
      1.2,
      1.2,
      1.2,
      1.2,
      2.36,
      2.36,
      2.36,
      2.36,
      2.36,
      2.36,
      2.36,
      2.36,
      4.32,
      4.32,
      4.32,
      4.32,
      4.32,
      4.32,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      5.92,
      2.56,
      2.56,
      2.56,
    ],
  },

  QSuperDeathTPDDefault: {
    startAge: 16,
    cost: [
      18.32,
      18.32,
      18.65,
      19.39,
      20.87,
      40.5,
      48,
      59.66,
      78.5,
      110.58,
      133.12,
      158.66,
      188.76,
      220.2,
      252.52,
      286.86,
      324.98,
      363.6,
      403.38,
      450.44,
      497.1,
      551.34,
      609.78,
      666.3,
      722.86,
      775.22,
      813.86,
      832.14,
      841.28,
      836.88,
      821.96,
      805.14,
      782.88,
      749.52,
      715.06,
      680.24,
      652.58,
      620.84,
      595.16,
      565.68,
      524.62,
      475.22,
      419.22,
      369.92,
      326.28,
      286.5,
      261.24,
      252.72,
      244.2,
      47.7,
      50.02,
      52.74,
      56.88,
      61.8,
      0,
      0,
    ],
  },

  QSuperDeathTPDPolice: {
    startAge: 16,
    cost: [
      26.58,
      27.09,
      27.52,
      28.5,
      30.48,
      59.54,
      70.06,
      88.2,
      115.96,
      164.36,
      196.82,
      236.96,
      282.2,
      327.74,
      378.4,
      425.26,
      474.64,
      523.38,
      574.78,
      633.28,
      688.54,
      752.5,
      819.72,
      884.08,
      945.84,
      975.14,
      977.24,
      973.56,
      971,
      967.3,
      964.74,
      962.28,
      957.38,
      957.38,
      937.16,
      900.06,
      863.4,
      821.4,
      787.34,
      748.28,
      694.02,
      628.6,
      554.4,
      489.22,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ],
  },
};
